import * as React from 'react';
import classnames from 'classnames';

const LineItemSubtitle = ({ className , subtitle  })=>/*#__PURE__*/ React.createElement("p", {
        className: classnames('line-item-subtitle', className)
    }, subtitle)
;

export { LineItemSubtitle as default };
//# sourceMappingURL=LineItemSubtitle.js.map
